import { type FC, memo } from 'react';
import styles from './index.module.scss';
import loadingIcon from '@assets/images/parrot/loading.svg';

interface OwnProps {
  size?: number;
  /**
   * Defaults `false`
   */
  centered?: boolean;
  className?: string;
}

const Loading: FC<OwnProps> = ({ size = 16, centered = false, className = '' }) => {
  return (
    <img
      width={size}
      height={size}
      className={`${styles.loading} ${centered ? styles.center : ''} ${className}`}
      src={loadingIcon}
    />
  );
};

export default memo(Loading);
